import { gatewayInstance } from "../axiosInstance";

export const ncrUpload = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/auditingservice/ncr-upload`,
      data,
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const getNcrRequestList = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/auditingservice/ncr-upload/search-request`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const getNcrDetailByNcrId = async (ncrId) => {
  try {
    const response = await gatewayInstance.get(
      `/auditingservice/ncr-upload/${ncrId}`,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};

export const ncrUpdate = async (ncrId, data) => {
  try {
    const response = await gatewayInstance.put(
      `/auditingservice/ncr-upload/update/${ncrId}`,
      data,
    );
    return response;
  } catch (e) {
    console.error(e);
  }
};

export const filterNcrList = async (data) => {
  try {
    const response = await gatewayInstance.post(
      `/auditingservice/ncr-upload/search-ncr`,
      data,
    );
    return response.data;
  } catch (e) {
    console.error(e);
  }
};
